import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'
import { request } from '../../api'

export const getStripeConfig = async(orgaId) => {
    return await axios.get(`${url}/stripe/config/${orgaId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const ConnectStripeAccount = async(code, userId, token) => {
    return await request('post', `stripe/connect/${userId}`, { code: code }, token)
}

export const DisconnectStripeAccount = async(token) => {
    return await request('delete', `stripe/disconnect`, {}, token)
}

export const ConnectCustomerAccount = async(email, name, token) => {
    return await request(
        'post',
        `stripe/customers`, {
            email: email,
            name: name,
        },
        token,
    )
}

export const GetSupportedPaymentCurrencies = async(account_id) => {
    return await axios.get(`${url}/stripe/supported-payment-currencies/${account_id}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getStripeInfo = async() => {
    return await axios.get(`${url}/stripe/account`, {
        headers: HeadersWithCredentials(),
    })
}

export const deleteCard = async(cardId) => {
    return await axios.delete(`${url}/stripe/delete-card/${cardId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getStripeAccountStatus = async(stripeAccountId) => {
    return await axios.get(`${url}/stripe/account-status/${stripeAccountId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getInvoiceUrl = `${url}/stripe/invoice-stream`

export const getInvoiceNumbersByOrga = async(orgaId) => {
    return await axios.get(`${url}/stripe/invoice-numbers/${orgaId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getMyInvoiceNumbers = async() => {
    return await axios.get(`${url}/stripe/my-invoice-numbers`, {
        headers: HeadersWithCredentials(),
    })
}
